import { toCsv } from './exportCells';

// Writes a table's export cells to a .csv and downloads it, laid out as AG's
// exportDataAsCsv writes one
const downloadTableCsv = ({
  cells,
  fileName,
}: {
  cells: DataTable.ExportCells;
  fileName: string;
}) => {
  const blob = new Blob([toCsv(cells)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.csv`);
  link.click();
  URL.revokeObjectURL(url);
};

export default downloadTableCsv;
